import React, {Component} from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
} from 'reactstrap';
import TranslationInput from '../../03-components/TranslationInput';
import CategorySelector from '../CategorySelector';
import {convertFromTranslationObject, convertToTranslationObject} from "../../05-utils/commonUtils";

export default class CategoryDialog extends Component {
	constructor(props) {
		super(props);
		this.handleClose = this.handleClose.bind(this);
		this.handleCategoryName = this.handleCategoryName.bind(this);
		this.editMode = props.options && props.options.editMode;
		this.state = {
			parentCategory: props.options && props.options.category && props.options.category.parentId,
			categoryName: props.options && props.options.category && props.options.category.name,
		};
		
		this.handleCategoryName = this.handleCategoryName.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleOK = this.handleOK.bind(this);
		this.handleCategoryParent = this.handleCategoryParent.bind(this);
	}
	
	handleCategoryParent(value) {
		this.setState({parentCategory: value});
	}
	
	handleCategoryName(values) {
		this.setState({categoryName: convertToTranslationObject(values)});
	}
	
	handleClose() {
		this.props.onClose && this.props.onClose();
	}
	
	handleOK() {
		this.props.onOK&& this.props.onOK(this.props.options, {
			parentCategory: this.state.parentCategory,
			categoryName: this.state.categoryName
		});
	}
	
	render() {
		return (
			<Modal isOpen={true}>
				<ModalHeader>{`${this.editMode ? "Edit" : "Add"} product category`}</ModalHeader>
				<ModalBody>
					<div className="input-group">
						<div className="label">
							Parent category
						</div>
						<CategorySelector value={this.state.parentCategory} onSelected={this.handleCategoryParent}
						                  disabled={this.props.progress}/>
					</div>
					<div className="input-group">
						<div className="label">
							Category name
						</div>
						<TranslationInput value={convertFromTranslationObject(this.state.categoryName)}
						                  disabled={this.props.progress} onValueChange={this.handleCategoryName}/>
					</div>
				</ModalBody>
				<ModalFooter>
					<fieldset disabled={this.props.progress}>
						<Button className="margin-right-15px" onClick={this.handleClose}>{"Cancel"}</Button>
						<Button className={this.props.progress ? "progress-button" : ""}
						        disabled={!this.state.categoryName}
						        color="primary"
						        onClick={this.handleOK}>{`${this.editMode ? "Save" : "Add"}`}
						</Button>
					</fieldset>
				</ModalFooter>
			</Modal>
		)
	}
	
}


// WEBPACK FOOTER //
// ./src/04-containers/CategoryDialog/index.js